

const Loader = () => {
  return (
    <div className='push-pop loader'>
      <div></div>
      <div></div>
    </div>
  )
}

export default Loader